module.exports = __webpack_public_path__ + "img/award.feb4bcf4.svg";